import { Controller } from "@hotwired/stimulus"

// Keeps the message list scrolled to the bottom as new content streams in.
// If the user manually scrolls up, auto-scroll pauses until they scroll back
// to the bottom.
export default class extends Controller {
  connect() {
    this.pinned = true
    this.element.addEventListener("scroll", this.onScroll.bind(this))
    this.scrollToBottom()

    // Re-pin on each Turbo Stream update
    this._observer = new MutationObserver(() => {
      if (this.pinned) this.scrollToBottom()
    })
    this._observer.observe(this.element, { childList: true, subtree: true, characterData: true })
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  onScroll() {
    const el = this.element
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50
    this.pinned = atBottom
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
